import * as React from 'react';

// Microsoft's four-square logo, in its brand colours. Used for the Microsoft
// custom-connector tile (SharePoint lists through Microsoft Graph).
export default ({ viewBox, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox={viewBox} style={style}>
    <rect width="40" height="40" rx="6" fill="#FFF" />
    <rect x="8" y="8" width="11.5" height="11.5" fill="#F25022" />
    <rect x="20.5" y="8" width="11.5" height="11.5" fill="#7FBA00" />
    <rect x="8" y="20.5" width="11.5" height="11.5" fill="#00A4EF" />
    <rect x="20.5" y="20.5" width="11.5" height="11.5" fill="#FFB900" />
  </svg>
);
